import React from 'react'
import Header from '../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../component/custom-hooks/get-nav';

const BillLayout = () => {
  const navList = useNav();
  let { billTopHeaderNav, billBottomNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={billBottomNav} topTabs={billTopHeaderNav} />
      <Outlet />
    </div>
  )
}

export default BillLayout
